module.exports = __webpack_public_path__ + "static/assets/20630c2b0b52e2ae3eb6fa7ef11d58be.gif";